import { memo, useRef } from 'react';
import IndianMusicPageContent from './components/IndianMusicPageContent';

export const IndianMusicPage = memo(() => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  return (
    <div className="flex flex-col h-full">
      <IndianMusicPageContent scrollContainerRef={scrollContainerRef} />
    </div>
  );
});

IndianMusicPage.displayName = 'IndianMusicPage';
